<template>
    <div class="hse">
        <div class="content" v-if="info.cardType == 0">
            <div class="wel">
                <div>欢迎进入电子资格证件查询服务系统</div>
                <div>钻井相关培训联系电话029-86587817</div>
            </div>
            <div class="time">
                <div class="tip">请确认当前查询时间</div>
                <div class="value">{{ curTime }}</div>
            </div>
            <div class="avatar-content">
                <img class="avatar" :src="host + info.avatar" />
            </div>
            <div class="row bg">
                <div class="label">证件类型</div>
                <div class="value">
                    <div class="value-content">{{ info.post }}</div>
                </div>
            </div>
            <div class="row">
                <div class="label">姓名</div>
                <div class="value">
                    <div class="value-content">{{ info.name }}</div>
                </div>
            </div>
            <div class="row bg">
                <div class="label">工作单位</div>
                <div class="value">
                    <div class="value-content">{{ info.company }}</div>
                </div>
            </div>
            <div class="row">
                <div class="label">证件号码</div>
                <div class="value">
                    <div class="value-content">{{ info.hseCode }}</div>
                </div>
            </div>
            <div class="row bg">
                <div class="label">证件有效期</div>
                <div class="value">
                    <div class="value-content">{{ `${genTime(info.startTime)}-${genTime(info.finishTime)}` }}</div>
                </div>
            </div>
        </div>
        <div class="out-box" v-if="info.cardType == 1">
            <div class="box-title">{{ info.cardName }}</div>
            <img class="box-avatar" :src="host + info.avatar" />
            <div class="cell">
                <div class="cell-title">培训项目：</div>
                <div class="cell-value">{{ info.name }}</div>
            </div>
            <div class="cell">
                <div class="cell-title">培训时间：</div>
                <div class="cell-value">{{ info.startTime }} 至 {{ info.finishTime }}</div>
            </div>
            <div class="cell">
                <div class="cell-title">班主任：</div>
                <div class="cell-value">{{ info.post }}</div>
            </div>
            <div class="cell">
                <div class="cell-title">发证机关：</div>
                <div class="cell-value">{{ info.publishOffice }}</div>
            </div>
            <div class="cell">
                <div class="cell-title">身份证号码：</div>
                <div class="cell-value">{{ info.cardNum }}</div>
            </div>
            <div class="cell">
                <div class="cell-title">证件编号：</div>
                <div class="cell-value">{{ info.certNum }}</div>
            </div>
            <div class="cell">
                <div class="cell-title">考试成绩：</div>
                <div class="cell-value">{{ info.hseCode }}</div>
            </div>
            <div class="cell">
                <div class="cell-title">工作单位：</div>
                <div class="cell-value">{{ info.company }}</div>
            </div>
            <div class="cell">
                <div class="cell-title">是否有效：</div>
                <div class="cell-value text-bold">{{ info.delTag == 0 ? '无效' : '有效' }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { NavBar, Image as VanImage, Cell, CellGroup } from "vant";
Vue.use(NavBar);
Vue.use(VanImage);
Vue.use(Cell);
Vue.use(CellGroup);
import { hseInfo } from "../../services/api/index";
import util from "../../utils";
export default {
    data() {
        return {
            id: "",
            info: {},
            host: process.env.VUE_APP_BASE_API,
            curTime: "",
            isNotWx: false,
        };
    },
    created() {
        this.id = util.getUrlParamByName("id");
        if (this.id) {
            this.getTime();
            this.init();
        } else {
            this.$router.push({
                path: "/home",
            });
        }
    },
    methods: {
        isWeixinBrowser() {
            // 检查User-Agent字符串中是否包含"MicroMessenger"
            return /MicroMessenger/i.test(navigator.userAgent);
        },
        getTime() {
            const time = new Date();
            const year = time.getFullYear();
            const mouth = time.getMonth() + 1;
            const day = time.getDate();

            const hour = time.getHours();
            const min = time.getMinutes();
            const sec = time.getSeconds();

            const mouthStr = mouth > 9 ? mouth : "0" + mouth;
            const dayStr = day > 9 ? day : "0" + day;
            const hourStr = hour > 9 ? hour : "0" + hour;
            const minStr = min > 9 ? min : "0" + min;
            const secStr = sec > 9 ? sec : "0" + sec;
            this.curTime = `${year}-${mouthStr}-${dayStr} ${hourStr}:${minStr}:${secStr}`;
        },
        async init() {
            const res = await hseInfo(this.id);
            if (res?.code === 200) {
                this.info = res.data;
                console.log(res.data)
                if (this.info.cardType == "1") {
                    document.title = "公司员工培训中心 员工培训管理平台";
                }
            }
        },
        genTime(time) {
            if (!time) return;
            const list = time.split("-");
            return list[0] + list[1] + list[2];
        },
    },
};
</script>

<style lang="scss">
.hse {
    height: 100%;

    .content {
        margin: 5px 12px;
        border: 1.5px solid #dddddd;
        font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
        color: #292929;

        .wel,
        .time {
            background: #f5f5f5;
            height: 44px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-bottom: 1.5px solid #dddddd;
            vertical-align: middle;
            font-size: 12.8px;
            line-height: 1.45;
        }

        .time {
            margin-top: 5px;
            border-top: 1.5px solid #dddddd;
        }

        .avatar-content {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 3px 8px;

            .avatar {
                width: 160px;
                height: 200px;
            }
        }

        .row {
            height: 38px;
            display: flex;
            align-items: center;
            border-top: 1.5px solid #dddddd;
            font-size: 13.5px;

            .label {
                width: 30%;
                border-right: 1.5px solid #dddddd;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding: 0 8px;
            }

            .value {
                width: 70%;
                padding: 0 8px;

                .value-content {
                    height: 31px;
                    background: #f5f5f5;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    border: 1.5px solid #dddddd;
                    padding: 0 3px;
                    color: #939192;
                }
            }
        }

        .bg {
            background: #f5f5f5;
        }
    }

    .out-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #f9f9f9;

        .box-title {
            font-size: 20px;
            font-weight: 600;
            font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC,
                Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial,
                sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
            text-align: center;
            margin: 14px 0;
        }

        .box-avatar {
            width: 94%;
            overflow: hidden;
        }

        .cell {
            display: flex;
            align-items: flex-start;
            width: 92%;
            font-size: 14px;
            padding: 14px 0;
            font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC,
                Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial,
                sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;

            &-title {
                width: 94px;
                color: rgba(0, 0, 0, 0.65);
                font-weight: 500;
            }

            &-value {
                flex: 1;
                color: #000000a6;
            }
        }
    }

    .text-bold {
        font-weight: 700;
    }

    .tip-box {
        font-size: 18px;
        color: #333;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 90%;

        .box-empty {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            font-size: 13px;
            color: #666;
            position: relative;

            img {
                width: 88px;
            }
        }

        .mask {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.6);
            color: #fff;
            font-size: 14px;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 25%;

            .right-icon {
                position: absolute;
                top: 16px;
                right: 20px;
            }
        }
    }
}

.loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: #666;
    position: absolute;
    top: 16%;
}

.demo2 {
    width: 4px;
    height: 6px;
    background: #68b2ce;
    float: left;
    margin: 0 3px;
    animation: demo2 1s linear infinite;
    -webkit-animation: demo2 1s linear infinite;
    margin-bottom: 16px;
}

.demo2:first-child {
    animation-delay: 0s;
}

.demo2:nth-child(2) {
    animation-delay: 0.15s;
}

.demo2:nth-child(3) {
    animation-delay: 0.3s;
}

.demo2:nth-child(4) {
    animation-delay: 0.45s;
}

.demo2:nth-child(5) {
    animation-delay: 0.6s;
}

@keyframes demo2 {
    0% {
        transform: scale(1);
    }

    30% {
        transform: scaleY(3);
    }

    60% {
        transform: scale(1);
    }

    100% {
        transform: scale(1);
    }
}
</style>
